// extracted by mini-css-extract-plugin
module.exports = {"head":"_product__head__zr0vs","accordion":"_product__accordion__rrFlQ"};